import type { Since } from "../api";

/**
 * What moved since last week, in the words a person would use.
 *
 * Every other surface answers "what is true now". This answers "what
 * changed since I last looked", which is the question somebody opens a
 * contract tool with on a Monday.
 *
 * It says nothing has moved when nothing has. A young instance will say
 * that for a while, which is true and more useful than a trend line
 * drawn through two points.
 */
export function SinceLast({ since }: { since: Since | undefined }) {
  if (!since) return null;

  if (since.moves === 0) {
    return (
      <p className="since since--quiet">
        Nothing has moved in the last {since.days} days.
      </p>
    );
  }

  return (
    <p className={`since${since.irreversible ? " since--lost" : ""}`}>
      <span className="since__k">In the last {since.days} days</span>
      {since.sentences.map((s, i) => (
        <span key={i} className="since__item">{s}</span>
      ))}
    </p>
  );
}
